// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"3ec0bc19","447":"275a3221","453":"bd88e0cf","755":"4500221d","857":"356dd3d5","869":"23bfb1bc","898":"180e6b57","943":"77d8e5ab"}[chunkId] + ".chunk.js";
};